import $ from 'jquery';
import React from 'react';
import { render } from 'react-dom';

import magnificPopup from 'magnific-popup'; // eslint-disable-line no-unused-vars
import api from '../common/services/api';
import { PARTNER_OFFERS_IS_AUTHENTICATED } from '../common/constants/global';
import bootstrapSite from '../app/bootstrapSite';
import getFromDataLayer from '../utilities/getFromDataLayer';
import { hasCookie } from '../utilities/cookie';
import { debounce } from '../utilities/functions';

import mobileFilters from '../components/mobileFilters';
import loadCarousel from '../components/loadCarousel';
import { accordions, mobileAccordions } from '../components/accordion';

import getMarkersApiArgs from '../components/Map/utilities/getMarkersApiArgs';
import { getPropertyFromUrl } from '../components/Map/utilities/getPropertyFromUrl';
import Icon from '../common/components/restyled/Icon';
import Button from '../common/components/restyled/Button';
import attachTooltip from '../common/helpers/tooltip/attachTooltip';

import bindSelectTracking from '../utilities/bindSelectTracking';

accordions();
mobileAccordions();
const debounceMobileAccordions = debounce(mobileAccordions, 50);
window.addEventListener('resize', debounceMobileAccordions);

// Load hotel carousel
loadCarousel();
bootstrapSite();
mobileFilters();

$('.mock-link').on('click', (event) => {
    event.stopPropagation();
});

$('.hotelcard-link, .villacard-link').on('click', (event) => {
    const cardHref = event.currentTarget.querySelectorAll('a')[0].getAttribute('href');
    window.location = cardHref;
});

const renderMapViewButton = (mapBox) => {
    const latitude = parseFloat(mapBox.getAttribute('data-latitude'));
    const longitude = parseFloat(mapBox.getAttribute('data-longitude'));
    const zoom = parseFloat(mapBox.getAttribute('data-zoom'));
    const tags = mapBox.getAttribute('data-searchtags').split('|');
    const propertyType = mapBox.getAttribute('data-prop');

    const markersAndMapType = getMarkersApiArgs(tags, propertyType);
    const filterForm = document.getElementById('plpFilters')?.length > 0;
    const mapViewButtonClass = filterForm ? 'map-view-button-filters map-view-button-wrapper' : 'map-view-button-wrapper';
    const filterOptions = {
        show: true,
        propertyType: getPropertyFromUrl(),
    };

    const MapViewButton = (
        <div class={mapViewButtonClass}> 
            <Button displayStyle='primary' size='medium' icons={{right: <Icon symbol='location' />}}>
                Map view
            </Button>
        </div>
    );

    const MapWithMarkers = import(/* webpackChunkName: "MapWithMarkers" */ '../components/Map');
    const PortalContainer = import(
        /* webpackChunkName: "PortalContainer" */ '../common/components/portal/PortalContainer'
    );

    Promise.all([MapWithMarkers, PortalContainer]).then((response) => {
        const [{ MapWithMarkers }, { default: PortalContainer }] = response;
        render(
            <PortalContainer button={MapViewButton}>
                <div className="map-modal">
                    <MapWithMarkers
                        latitude={latitude}
                        longitude={longitude}
                        zoom={zoom}
                        markersApiArgs={markersAndMapType.mapWithArgs}
                        mapType={markersAndMapType.mapType}
                        showFilters={filterOptions}
                    />
                </div>
            </PortalContainer>,
            mapBox
        );
    });
};

const renderPasswordOverlay = () => {
    const partnerOfferDetails = getFromDataLayer(window.dataLayer, 'partnerOffer');

    // TODO check if cookie exists for password and don't show overlay

    const hasPartnerAuthCookie = hasCookie(PARTNER_OFFERS_IS_AUTHENTICATED);

    if (partnerOfferDetails && !hasPartnerAuthCookie) {
        const partnerOffersRoot = document.createElement('div');
        partnerOffersRoot.setAttribute('id', 'partnerOffersRoot');

        const Modal = import(/* webpackChunkName: "Modal" */ '../common/components/modal/Modal');
        const PartnerOffersContainer = import(
            /* webpackChunkName: "PartnerOffersContainer" */ '../common/components/PartnerOffersContainer'
        );

        Promise.all([Modal, PartnerOffersContainer]).then((response) => {
            const [{ default: Modal }, { default: PartnerOffersContainer }] = response;

            render(
                <Modal allowOverlayDismiss={false}>
                    <PartnerOffersContainer partnerOffers={partnerOfferDetails} />
                </Modal>,
                document.getElementById('partnerOffersRoot')
            );
        });
    }
};

window.addEventListener('load', () => {
    $('.tc-modal').magnificPopup({
        type: 'inline',
        preloader: false,
    });

    $(document).on('click', '.tc-modal-dismiss', (event) => {
        event.preventDefault();
    });

    renderPasswordOverlay();

    // Render Tooltip
    const allTooltips = document.querySelectorAll('.js-tooltips');
    const tooltipCount = allTooltips.length > 0;

    if (tooltipCount) {
        const bestPriceAndExtras = document.querySelectorAll('div[data-title="Best-price guarantee"], .c-tooltip__cta--smith-extra');

        Array.from(bestPriceAndExtras).forEach((tooltip) => {
            const { title, message, direction } = tooltip.dataset;

            attachTooltip(tooltip, {
                interaction: 'manual',
                preferredAlignment: {
                    vertical: direction === 'top' ? 'top' : 'bottom',
                    horizontal: 'center',
                },
                triggerContent: (
                    <span className="c-tooltip">
                        <Icon symbol="info-circle" className="left-icon" />
                        <span className="c-tooltip__title">{title}</span>
                        <Icon symbol="check-circle" className="right-icon" />
                    </span>
                ),
                children: <div dangerouslySetInnerHTML={{ __html: message }} />,
            });
        });

        import(/* webpackChunkName: 'renderTooltips' */ '../common/helpers/tooltip/renderTooltips').then(
            ({ default: renderTooltips }) => {
                const allInclusive = document.querySelectorAll('div[data-title="All-inclusive"]');

                Array.from(allInclusive).forEach((tooltip) => {
                    const inclusiveUrl = tooltip.getAttribute('data-urlInclusive');

                    api.getInclusiveDetails(inclusiveUrl).then((response) => {
                        tooltip.setAttribute(
                            'data-message',
                            `<p class="c-tooltip__ctaMessage">${response.data}</p>`
                        );
                        renderTooltips(tooltip);
                    });
                });
            }
        );
    }

    // Map View Button
    const mapBox = document.querySelector('.j-map-box');
    if (mapBox) {
        renderMapViewButton(mapBox);
    }

    // Map Pin
    import(/* webpackChunkName: "InitialisePropertyMap" */ '../common/components/InitialisePropertyMap').then(
        ({ default: InitialisePropertyMap }) => {
            InitialisePropertyMap();
        }
    );

    // Favorites
    import(/* webpackChunkName: "renderFavouritesButton" */ '../common/helpers/favourites/renderFavouritesButton').then(
        ({ default: renderFavouritesButton }) => {
            renderFavouritesButton();
        }
    );

    const sortTypeSelect = document.getElementById("s_sort_type");
    const resultsLimitSelect = document.getElementById("s_limit");

    if (sortTypeSelect) {
        bindSelectTracking(sortTypeSelect, 'sortBy');
    }
    if (resultsLimitSelect) {
        bindSelectTracking(resultsLimitSelect, 'resultsLimit');
    }
});
